import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { DeviationTypes } from '../../../../../../types/deviation';
import { getDeviationType, getDeviationUrl } from '../../../../../_helpers';
import { useWatchButton } from '../../../../../../WatchButton/useWatchButton';
var unlockHint = function (type, isMobile) {
    if (type === DeviationTypes.FILM) {
        return isMobile
            ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile.video'
            : 'deviationview.overlay.premiumFolder.unlockHint.watch.video';
    }
    return isMobile
        ? 'deviationview.overlay.premiumFolder.unlockHint.watch.mobile'
        : 'deviationview.overlay.premiumFolder.unlockHint.watch';
};
var WatchersOnlyMiddleContent = function (_a) {
    var deviation = _a.deviation, thumbWidth = _a.thumbWidth, thumbHeight = _a.thumbHeight, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var redirectOnWatch = useCallback(function () {
        window.location.href = getDeviationUrl(deviation);
    }, [deviation]);
    var _b = useWatchButton(deviation.author, undefined, undefined, false, redirectOnWatch), text = _b.text, onClick = _b.onClick, biData = _b.biData;
    var canShowDescription = thumbWidth &&
        thumbWidth > 150 &&
        (thumbWidth > 270
            ? thumbHeight && thumbHeight > 240
            : thumbHeight && thumbHeight > 260);
    var canShowButton = thumbHeight && thumbHeight > 210;
    var isUnreasonablySmall = (thumbHeight && thumbHeight < 160) || (thumbWidth && thumbWidth < 120);
    if (isUnreasonablySmall) {
        return (React.createElement(HoverOnly, { reverseHidden: true },
            React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-watchers-only", size: "large" }), className: className })));
    }
    return (React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-watchers-only", size: "large" }), subtitle: canShowDescription
            ? t(unlockHint(getDeviationType(deviation), isMobile))
            : undefined, buttonTitle: canShowButton ? text : undefined, onButtonClick: onClick, biData: biData, className: className }));
};
WatchersOnlyMiddleContent.displayName = 'WatchersOnlyMiddleContent';
export default WatchersOnlyMiddleContent;
//# sourceMappingURL=WatchersOnlyMiddleContent.js.map